<template>
  <div id="activity">
    <welcome :src="cover"></welcome>
    <banner :src="banner"></banner>
    <activity-info
      :title="activity.name"
      :pv="activity.count.pv"
      :details="activity.details"
      :total="photos.newest.length"
      :src="activity.banner"
    />
    <function-bar
      :categories="categories"
      @changeCategory="changeCategory"
      @changeArrange="changeArrange"
      @changeToMergePicMode="changeToMergePicMode"
      ref="functionBar"
    />
    <image-wall
      :title="activity.name"
      :images="filterPhotos()"
      :pswp="this.$refs.fullscreenPhoto"
      :showMergePicMode="showMergePicMode"
      ref="imageWall"
    />
    <fullscreen-photo
      :images="filterPhotos()"
      :index="0"
      @updateSrc="updateSrc"
      ref="fullscreenPhoto"
    />
    <faceid-button
      v-if="activity.showFaceRecognition===1"
      @selectSuccess="selectSuccess"
      :positionNum="(activity.showReserve===0 && activity.showFaceRecognition===1)? 12 : 17"/>
    <reserve-button v-if="activity.showReserve===1" :imageWall="this.$refs.imageWall" />
    <qrcode-button :qrcodeUrl="activity.qrcode" :qrcodeDesc="activity.qrcodeDesc" />
    <refresh-button @refresh="refresh"/>
  </div>
</template>

<script>
import Welcome from '@/components/welcome.vue'
import Banner from '@/components/banner.vue'
import ActivityInfo from '@/components/activity-info.vue'
import FunctionBar, { arrangeType, makeBar } from '@/components/function-bar.vue'
import ImageWall from '@/components/image-wall.vue'
import FullscreenPhoto from '@/components/fullscreen-photo.vue'
import RefreshButton from '@/components/refresh-button.vue'
import QrcodeButton from '@/components/qrcode-button.vue'
import ReserveButton from '@/components/reserve-button.vue'
import FaceidButton from '@/components/faceid-button.vue'
import wx from 'weixin-js-sdk'
import Vue from 'vue'

export default {
  components: {
    Welcome,
    Banner,
    ActivityInfo,
    FunctionBar,
    ImageWall,
    FullscreenPhoto,
    RefreshButton,
    QrcodeButton,
    ReserveButton,
    FaceidButton
  },
  data() {
    return {
      title: '',
      cover: '',
      banner: '',
      theme: 'black',
      details: '',
      activity: {
        details: null,
        banner: null,
        cover: null,
        name: null,
        qrcodeDesc:null,
        count: {
          ip: null,
          pv: null,
        },
        wechatIcon:null,
      },
      categories: [],
      photos: {
        newest: [],
        hot: []
      },
      currentArrangeType: '',
      currentCategory: '',
      showMergePicMode: false,
      form:{
        activity:'',
        name:'',
        mobile:'',
        company:'',
        smsCode:'',
        message:'',
      },
      sendMsgDisabled: false,
      selectPhotos:[],
    }
  },
  mounted() {
    this.currentArrangeType = this.$refs.functionBar.arrangeType.newest
    this.getBasicActivityInfo()
    this.getActivityInfo()
  },
  methods: {
    wxinit(title, desc, coverUrl) { 
      console.log('wxinit')
      Vue.axios.get("/sign").then(({ status, data }) => {
        if(status === 200 && data) {
          let param = {
            debug:false,
            url:window.location.href,
            jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareQZone']
          }
          let param2=Object.assign(param, data)
          wx.config(param2);
          wx.ready(()=>{
            console.log('wx.ready');
            let shareImg="http://"+ window.location.hostname+ encodeURI(coverUrl);
            shareImg=shareImg.replace(/uploads/g,"uploadsthumb");
            console.log("shareImg:"+ shareImg);

            wx.onMenuShareTimeline({
              title, //
              desc, //
              link: window.location.href, //
              imgUrl: shareImg, // 
              success: function(res) {
              },
              cancel: function(res) {
              }
            });
            wx.onMenuShareAppMessage({
              title, // 
              desc, //
              link: window.location.href, // 
              imgUrl: shareImg, // 
              success: function(res) {
              },
              cancel: function(res) {
              }
            });
          });	
          wx.error(function(res){
            console.log('wx err',res);
          });
        }
      });
    },
    refresh(notCount, callback) {
      console.log('refresh')
      Vue.axios.post(`/api/activity`, {
          activityId: this.$route.params.id,
          count: !notCount
        }).then((res) => {
          //console.log(res.data.result)
          const {activity, categories, photos} = res.data.result
          this.activity = activity
          console.log(this.activity)
          this.categories = categories.map(({name})=>name)

          //视频
          if(activity.showVideo === 1) {
            this.categories.push(i18n.t('functionBar.video'))
            const bars = {
              category: this.$refs.functionBar.bars.category,
              video: makeBar(i18n.getLocaleMessage('zh-cn').functionBar.video, i18n.t('functionBar.video')),
              arrange: this.$refs.functionBar.bars.arrange,
              merge: this.$refs.functionBar.bars.merge,
            }
            this.$refs.functionBar.bars = bars
          }
          
          //人脸选图
          if(activity.showFaceRecognition === 1){
            this.categories.push(i18n.t('imagewall.selfieTitle'))
          }

          //console.log(this.categories)
          this.photos = this.sortPhotos(photos)
        })
        if (typeof callback === 'function') callback();
    },
    getActivityInfo(){
      // console.log('getActivityInfo')
      Vue.axios.post(`/api/activity`, {
          activityId: this.$route.params.id,
          count: true
        }).then((res) => {
          console.log(res.data.result)
          const {activity, categories, photos} = res.data.result
          this.activity = activity
          this.categories = categories.map(({name})=>name)
          console.log(this.categories)

          //视频
          if(activity.showVideo === 1) {
            this.categories.push(i18n.t('functionBar.video'))
            const bars = {
              category: this.$refs.functionBar.bars.category,
              video: makeBar(i18n.getLocaleMessage('zh-cn').functionBar.video, i18n.t('functionBar.video')),
              arrange: this.$refs.functionBar.bars.arrange,
              merge: this.$refs.functionBar.bars.merge,
            }
            this.$refs.functionBar.bars = bars
          }
          
          //人脸选图
          if(activity.showFaceRecognition === 1){
            this.categories.push(i18n.t('imagewall.selfieTitle'))
          }

          //console.log(this.categories)
          this.photos = this.sortPhotos(photos)
          // console.log(this.photos)
          // console.log('getActivityInfo done')
        })
    },
    getBasicActivityInfo(){
      // console.log('getBasicActivityInfo')
      const activityId = this.$route.params.id
      Vue.axios.post(`/api/basicactivity`, {
        activityId,
      }).then(({status, data}) => {
        if(status === 200 && data && data.result) {
          const {title, banner, cover, details, theme, wechatIcon, accessCode } = data.result.activity
          this.$route.meta.title = title
          this.title = title
          this.banner = banner
          this.cover = cover
          this.theme = theme
          this.details = details
          // 微信分享初始化
          const wxCoverUrl = wechatIcon === '' ? cover : wechatIcon;
          this.wxinit(title, details, wxCoverUrl);
          //主题
          if(this.theme == 'white'){
            // require('./../assets/css/activity/theme-white.sass')
            console.log("white ok")            
          } else if(this.theme == 'red'){
            document.querySelector('body').setAttribute('style', 'background-color:#aa2116;')
            // require('./..//assets/css/activity/theme-black.sass')//默认样式
            console.log("red ok")
          } else{
            document.querySelector('body').setAttribute('style', 'background-color:#0D0D0D;')
            // require('./..//assets/css/activity/theme-black.sass')//默认样式
            console.log("black ok")
          }
          //this.$parent.$data.theme = theme || 'black'
          this.$store.state.theme = theme
          //访问密码
          const accessChecked = sessionStorage.getItem(this.$md5(activityId)) !== null
          if(!accessChecked && accessCode === true){
            sessionStorage.setItem(this.$md5(activityId + 'title'), title)
            this.$router.push({ name: 'access', params: { id: activityId } })
          }

          // console.log('getBasicActivityInfo done')
        }
      })
    },
    selectSuccess(photos){
      this.currentCategory = i18n.t('imagewall.selfieTitle')
      console.log(this.photos, photos)
      var selectList = []
      for (let i = 0; i < photos.length; i++) {
        const photoStr = photos[i];
        for (let j = 0; j < this.photos.hot.length; j++) {
          const el = this.photos.hot[j];
          const checkurl = el.url.substring(0, el.url.lastIndexOf("."))
          console.log("j", j, checkurl, photoStr)
          if(checkurl === photoStr) {
            selectList.push(el)
            break
          }
        }
      }
      this.selectPhotos = selectList
      this.$refs.functionBar.switchItems('category', i18n.t('imagewall.selfieTitle'))
    },
    sortPhotos(photos) {
      const hot = photos.slice(0).sort((a, b) => b.heat - a.heat);
      const newest = photos.slice(0).sort((a, b) => Number(b.createTime) - Number(a.createTime));
      return { hot, newest }
    },
    changeCategory(event) { 
      this.currentCategory = event;  
      if(event === i18n.t('functionBar.video')){
        this.$store.state.isShowVideoMode = true;
      }else{
        this.$store.state.isShowVideoMode = false;
      }
    },
    changeArrange(event) { this.currentArrangeType = event; },
    changeToMergePicMode(showMergePicMode) {
      //console.log(showMergePicMode)
      this.showMergePicMode = showMergePicMode;
    },
    filterPhotos() {
      let photos = (this.currentArrangeType === arrangeType.newest ? (
        this.photos.newest
      ) : (
        this.photos.hot
      )).slice(0);
      if (this.currentCategory !== '') {
        photos = photos.filter(({ category }) => {
          if(this.currentCategory === category) {
            return true; //图片
          } else { 
            return this.currentCategory===i18n.t('functionBar.video') && 'video' === category
          }
        });
      } else {
          photos = photos.filter(({ category }) => {
          return 'video' !== category
        });
      }
      if (this.currentCategory === i18n.t('imagewall.selfieTitle')){
        photos = this.selectPhotos
      }
      //console.log(photos.length,photos)
      return photos;
    },
    updateSrc(currentSrc, nextSrc) {
      let photos = this.photos.newest.map((infos) => {
        if (infos.url === currentSrc) {
          infos.url = nextSrc;
        }
        return infos;
      });
      this.photos = this.sortPhotos(photos);
    }
  }
}
</script>
